export default {
    "fr": {
        "Performances": "Performances",
        "Quick view": "Vue rapide",
        "Missions by type": "Missions par type",
        "No missions by this type": "Aucune mission de ce type"
    },
    "en": {
        "Performances": "Performances",
        "Quick view": "Quick view",
        "Missions by type": "Missions by type",
        "No missions by this type": "No missions by this type"
    }
}
